module.exports = __webpack_public_path__ + "img/CDCK.416aa1b6.jpg";